export const CLEAR_SET_RESULT = "CLEAR_SET_RESULT";
export const MODIFY_SET_RESULT = "MODIFY_SET_RESULT";
export const FETCH_SET_RESULT = "FETCH_SET_RESULT";
export const LIST_SET_RESULT = "LIST_SET_RESULT";
export const ERROR_SET_RESULT = "ERROR_SET_RESULT";

export const MODIFIED_POST_RELEASE = "MODIFIED_POST_RELEASE";